// utils/filterData.js

/**
 * Filters the provided providers based on selected support terms and selected advanced search terms.
 *
 * @param {Array} originalData - The full array of provider objects.
 * @param {Array} selectedSupports - Array of selected support term IDs (as strings).
 * @param {Array} selectedAdvSearch - Array of selected advanced search term IDs (as strings).
 *
 * @returns {Array} The fully filtered array of provider objects.
 */
export function filterProviders(originalData, selectedSupports, selectedAdvSearch) {
  // First filter by support terms:
  let supportFilteredData;

  if (selectedSupports.includes("none")) {
    supportFilteredData = originalData.filter(item => item.support_terms.length === 0);
  } else if (selectedSupports.length === 0) {
    supportFilteredData = originalData;
  } else {
    supportFilteredData = originalData.filter(item => {
      const termIds = item.support_terms.map(t => t.term_id.toString());
      return selectedSupports.some(supportId => termIds.includes(supportId));
    });
  }

  // Then filter by advanced search terms:
  let fullyFilteredData;
  if (selectedAdvSearch.length === 0) {
    fullyFilteredData = supportFilteredData;
  } else {
    // If any of the selected advanced search terms match the provider, include it
    fullyFilteredData = supportFilteredData.filter(item => {
      const advTermIds = item.advanced_services.map(t => t.term_id.toString());
      return selectedAdvSearch.some(advId => advTermIds.includes(advId));
    });
  }

  return fullyFilteredData;
}
